import { makeVar } from '@apollo/client';
import { IGridSortingVars } from '../../../.starryUI/globalTypes';

export const entryDirectorySorting = makeVar<IGridSortingVars>({ field: '', order: 'ASC' });
export const entryDirectoryCurrentPage = makeVar<number>(1);
export const entryDirectoryPageAmount = makeVar<number>(Number(localStorage.getItem('entryDirectoryPageAmount')) || 50);
export const entryDirectorySearchFor = makeVar<string>('');
